import { AfterViewInit, Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { StandingdataDataService } from "@app/standingdata/shared/standingdata.service";
import { CerrixSelectTreeComponent } from "@app/shared/cerrix-select-tree/cerrix-select-tree.component";
import { CerrixTreeItem } from "@models/tree/CerrixTreeItem";
import { ProcessEditorDataService } from "@services/http/processeditor/ProcessEditorDataService";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/process-editor/i18n/scope";
import { Observable } from "rxjs";

export interface FilterOutput {
    organization: number | null | undefined;
    businessDimension: number;
}

@Component({
    selector: "process-editor-filter",
    templateUrl: "./filter.component.html",
    styleUrls: ["./filter.component.scss"],
    imports: [MatTooltipModule, CerrixSelectTreeComponent, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class FilterComponent implements AfterViewInit {
    private _standingDataService = inject(StandingdataDataService);
    private _processDataService = inject(ProcessEditorDataService);

    @Input() isViewer: boolean;
    @Output() onApplyFilter = new EventEmitter<FilterOutput>();

    selectedOrganizationId: number | null | undefined;
    selectedBusinessDimensionId: number;

    orgRequest: Observable<CerrixTreeItem[]>;
    bdRequest: Observable<CerrixTreeItem[]>;

    parentForm: FormGroup;

    ngAfterViewInit() {
        this.setOrgTree();
        this.setBdTree();
    }

    reloadBusinessData() {
        this.setBdTree();
    }

    setFilterSelection(input: FilterOutput) {
        this.selectedOrganizationId = input.organization;
        this.selectedBusinessDimensionId = input.businessDimension;
        this.reloadBusinessData();
        this.applyFilter();
    }

    applyFilter() {
        this.onApplyFilter.emit({
            organization: this.selectedOrganizationId,
            businessDimension: this.selectedBusinessDimensionId,
        });
    }

    private setOrgTree() {
        const orgCall = this.isViewer
            ? this._processDataService.getViewerOrganizations()
            : this._processDataService.getEditorOrganizations();

        this.orgRequest = orgCall;
    }

    private setBdTree() {
        let bdCall;
        if (!this.selectedOrganizationId) {
            if (this.isViewer) {
                bdCall = this._processDataService.getViewerBusinessDimensions();
            } else {
                bdCall = this._processDataService.getEditorBusinessDimensions();
            }
        } else {
            bdCall = this._standingDataService.getBusinessDimensionsByOrganization(
                this.selectedOrganizationId,
                this.selectedBusinessDimensionId
            );
        }

        this.bdRequest = bdCall;
    }
}
